import { useEffect, useState } from "react"
import { faEdit, faTrashCan } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { loadAllUsers } from "../../services/documents/documents.context";
import { formatUrl } from "../../helpers/parse-url";


export const Usersdata = ({ data }) => {

    const [dataAction, setDataAction] = useState(null);
    const [dataId, setDataId] = useState();
    const [uniData, setUnitData] = useState(null);
    const [users, setUsers] = useState(data);
    const [all, setAll] = useState([])

    const navigateTo = useNavigate();

    function areStringsSimilarByPattern(str1, str2) {
        // Escape special regex characters in str1 to treat it as a literal pattern
        const escapedStr1 = str1.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Create a regex that matches the escaped string, allowing for variations (e.g., case-insensitivity)
        const regex = new RegExp(escapedStr1, 'i'); // 'i' for case-insensitive
        return regex.test(str2);
    }



    const searchEmail = (input_array, inpt) => {
        const matches = input_array?.filter((data) => areStringsSimilarByPattern(inpt, data?.email));
        return matches;
    }

    useEffect(() => {
        setUsers(data);
        /** all users */
        const getallUsers = async () => {
            const allUsers = await loadAllUsers();
            setAll(allUsers);
        }
        ( async() => { await getallUsers()})();
    }, [data])

    return (
        <div className="data-container">
            <div className="search-box">
                <div className="search-input-box">
                    <img src="/svgs/search-icon.svg" alt="" width={24} className="search-icon" />
                    <input
                        type="search"
                        className="search-input"
                        placeholder="Enter title of lecture notes"
                        onChange={(e) => setUsers(searchEmail(all, e.target.value))}
                    />
                </div>
            </div>

            <div className="titles-box">
                <div className={classNames("user-info", "caps")}>User Info</div>
                <div className={classNames("user-title", "caps")}>email</div>
                <div className={classNames("user-role", "caps")}>Role</div>
                <div className={classNames("modify", "caps")}>Edit/Delete</div>
            </div>
            <div className="info-details">
                {users?.map((d, indx) => {
                    return (
                        <div
                            className={classNames("info-box", { "even": indx % 2 === 0 })}
                            key={indx}
                        >
                            <div className="data-box">
                                <div className={classNames("user-info", "info-data")}>
                                    <img
                                        src={d?.avatar ? formatUrl(d?.avatar) : "/media/peer.png"}
                                        alt=""
                                        className="user-avatar"
                                    />
                                    {(d?.names)}
                                </div>
                                <div className={classNames("user-title", "info-data")}>
                                    {d?.email}
                                </div>
                                <div className={classNames("user-role", "info-data")}>
                                    <span className="role-data">{d?.role}</span>
                                </div>
                                <div className={classNames("modify", "info-data")}>
                                    <button
                                        className="mod-button"
                                        onClick={() => {
                                            setDataAction("edit");
                                            setDataId(d?._id);
                                            setUnitData(d);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEdit} className="mod-icon" />
                                    </button>
                                    <button
                                        className="mod-button"
                                        onClick={() => {
                                            setDataAction("delete");
                                            setDataId(d?._id);
                                            setUnitData(d);
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrashCan} className="mod-icon" />
                                    </button>
                                </div>
                            </div>
                            {(dataAction === "delete" && dataId === d?._id) &&
                                <div className="del-section">
                                    <span className="warning-msg">
                                        {`Delete ${d?.names}'s account? 
                                       This action is irreversible!`
                                        }
                                    </span>
                                    <button className="del-mod-button">Delete</button>
                                    <button
                                        className="del-mod-button"
                                        onClick={() => {
                                            setDataAction(null);
                                            setDataId(null);
                                            setUnitData(null);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            }

                            {(dataAction === "edit" && dataId === d?._id) &&
                                <div className="edit-section">
                                    <span className="edit-msg">
                                        {`Update account data for ${d?.names}?`}
                                    </span>
                                    <button
                                        className="del-mod-button"
                                        onClick={() => {
                                            navigateTo("/userupdate", { state: { account: d } })
                                        }}
                                    >
                                        Update
                                    </button>
                                    <button
                                        className="del-mod-button"
                                        onClick={() => {
                                            setDataAction(null);
                                            setDataId(null);
                                            setUnitData(null);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            }
                        </div>
                    )
                })}
            </div>
        </div>
    )
}